export const config = {
  title: "Pro Floor",
  meta: {
    description:
      "Pro Floor is a family‑owned flooring contractor in Lanham, MD offering hardwood, laminate, vinyl installation & refinishing since 2000.",
    keywords: [
      "Pro Floor Lanham MD",
      "Lanham flooring contractor",
      "vinyl floor installation Lanham",
      "hardwood floor refinishing Lanham",
      "family owned flooring"
    ],
    author: "Pro Floor",
    canonicalUrl: "https://www.myprofloor.com/",
  },
  sections: {
    header: {
      businessName: "Pro Floor",
    },
    sectionB: {
      heroTitle: "Pro Floor",
      heroSubtitle: "Premier Flooring Contractor Serving Lanham, MD",
      learnAboutText: "Explore Our Services",
      phoneNumber: "2405807257",
      phoneLabel: "(240) 580‑7257",
      heroBackgroundImage:
        "https://assets.voolt.com/Production/w-42122/lao8ngYOLEy8XXj_J_1muw_fcdf06a1-11c0-4f0d-b704-9fe7e10d5c55.jpg",
      cardData: [
        {
          title: "Vinyl Installation",
          description: "Professional luxury vinyl plank and tile flooring.",
        },
        {
          title: "Hardwood Refinishing",
          description: "Expert sanding and refinishing to restore hardwood floors.",
        },
        {
          title: "Laminate Flooring",
          description: "Durable and cost‑effective laminate floor options.",
        },
      ],
      description:
        "Family‑owned since 2000, Pro Floor delivers satisfaction‑guaranteed services with next‑day scheduling and flooring craftsmanship across Lanham and nearby communities.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We specialize in luxury vinyl, hardwood refinishing, laminate installation, and custom flooring solutions.",
      cards: [
        {
          title: "Luxury Vinyl",
          description: "Water‑resistant, stylish vinyl flooring for modern homes.",
          imageSrc: "https://assets.voolt.com/assets/2023/01/13235635/service-block-vinyl-floor-installation-1000x1000-1.jpg",
          imageAlt: "Luxury Vinyl Flooring",
        },
        {
          title: "Hardwood Refinishing",
          description: "Restoration and staining for a refreshed hardwood floor.",
          imageSrc: "https://assets.voolt.com/assets/2023/01/13235817/service-block-hardwood-floor-installation-1000x1000-1.jpg",
          imageAlt: "Hardwood Refinishing",
        },
        {
          title: "Laminate Floors",
          description: "Cost‑effective, durable laminate flooring installation.",
          imageSrc: "https://assets.voolt.com/assets/2023/02/13220655/service-block-laminate-floor-installation-1000x1000-1.jpg",
          imageAlt: "Laminate Flooring",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Floor Repair & Resurfacing",
        "Staircase Flooring",
        "Free Quotes & Consultations",
        "Commercial Install Projects",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://assets.voolt.com/Production/w-42122/DI201tXvOUeq17Iyz67FSA_cropped.png",
        alt: "Pro Floor Crew",
      },
      aboutText: [
        "Pro Floor is a dedicated, family‑owned flooring contractor based in Lanham, Maryland, providing quality and quick service since 2000.",
        "Our team is committed to delivering excellent flooring projects with a satisfaction guarantee and next‑day scheduling."
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Pro Floor Logo",
      businessName: "Pro Floor",
      contact: {
        phone: "2405807257",
        phoneLabel: "(240) 580‑7257",
        email: "floorproject10@gmail.com",
        website: "https://www.myprofloor.com/",
        address: "Lanham, MD (Serving Lanham & Nearby Areas)",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Lanham, MD",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3069.0!2d-76.885!3d39.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sLanham%2C+MD!5e0!3m2!1sen!2sus!4v1718660000000!5m2!1sen!2sus"
    }
  }
};

export default config;
